import React from "react";
import "./CityWiseTest.css";
import plus from  "../../../Assets/Test_icon-add.svg";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { AiOutlinePlus } from "react-icons/ai"

const testData = [
    {
      id: 1,
      title: "Smart Full Body",
      link:"smart-full-body-checkup",
    },
    {
      id: 2,
      title: "Pcos Basic Screening",
      link:"pcos-test",
    },
    {
      id: 3,
      title: "Blood Sugar Test",
      link:"blood-sugar-test-package",
    },
    {
      id: 4,
      title: "Arthritis Profile Test",
      link: "arthritis-profile-test",
    },
    {
        id: 5,
        title: "CBC Test",
        link:"cbc-test",
      },
      {
        id: 6,
        title: "STD Testing",
        link:"std-testing",
      },
      {
        id: 7,
        title: "ESR Test",
        link:"esr-test",
      },
      {
        id: 8,
        title: "Cholesterol Test",
        link:"cholesterol-test",
      },

      {
        id: 9,
        title: "Triple Maker Test",
        link:"triple-marker-test",
      },
      {
        id: 10,
        title: "Diabetes Screening",
        link:"diabetes-screening",
      },
      {
        id: 11,
        title: "Liver Function Test (LFT)",
        link:"liver-function-test-lft",
      },
      {
        id: 12,
        title: "Creatinine Test",
        link:"creatinine-test",
      },

    {
      id: 13,
      title: "Vitamin D Test",
      link:"vitamin-d-test",
    },
    {
      id: 14,
      title: "Kidney Function Test (KFT)",
      link:"kidney-function-test-kft",
    },
    {
      id: 15,
      title: "Follicle Stimulating Hormone FSH Test",
      link:"follicle-stimulating-hormone-fsh-test",
    },
    {
      id: 16,
      title: "Vitamin B12 Test",
      link:"vitamin-b12-test",
    },
    {
        id: 17,
        title: "CPR Test (C Reactive Protein Test)",
        link:"crp-test",
      },

      {
        id: 18,
        title: "Anti Mullerian hormone AMH Test",
        link:"anti-mullerian-hormone-amh-test",
      },
      {
        id: 19,
        title: "Prolactin Test",
        link:"prolactin-test",
      },
      {
        id: 20,
        title: "Hemoglobin Variant Analysis Test",
        link:"hemoglobin-variant-test",
      },
      {
        id: 21,
        title: "Healthy Heart Package",
        link:"healthy-heart-package",
      },

    {
      id: 22,
      title: "Fatigue Syndrome Test",
      link:"fatigue-syndrome-test",
    },
    {
      id: 23,
      title: "Thyroid Profile Total",
      link:"thyroid-test",
    },
    {
      id: 24,
      title: "Follicle Stimulating Hormone FSH Test",
      link:"follicle-stimulating-hormone-fsh-test",
    },
    {
      id: 25,
      title: "Fitness Check Package",
      link:"fitness-check-package",
    },
  ];

const CityWiseTest = () => {
  const citySelected = useSelector((state) => state.cityOnTopNav);
    return (
      <div className="container">
         <div className="background">
            <div className="popularTest">
            <p >Popular Tests
            </p>
            </div>
            {testData.map((values) => (
              <Link to={`${values.link}`}>
                    <div className="flex-container"> 
                     
                    <p className="valuesTitle">{values.title}</p>
                    <span className="plusIconPadding" >
                      <AiOutlinePlus />

                    </span>
                  </div>
                  </Link>
                  ))}
            
        </div>
      </div>
       
    )
}

export default CityWiseTest;